import { Card, Row, Col, Statistic, Table } from 'antd';
import {
  DollarOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useQuery } from 'react-query';
import { invoicesAPI, portfolioAPI } from '../api/endpoints';
import { formatCurrency, formatDate, formatPeriod } from '../utils/helpers';
import './DashboardPage.scss';

const DashboardPage = () => {
  const { data: invoicesData } = useQuery(['invoices', { page_size: 1000 }], () => invoicesAPI.list({ page_size: 1000 }));
  const { data: overdueData } = useQuery('overdue', () => invoicesAPI.overdue());
  const { data: portfolioReportData } = useQuery('portfolio-report', () => portfolioAPI.getReports());

  const allInvoices = invoicesData?.data?.results || [];
  const invoices = allInvoices.filter((inv) => inv.status !== 'draft');
  const overdue = overdueData?.data?.results || [];
  const portfolioReport = portfolioReportData?.data?.results?.[0] || {};

  const totalPending = invoices.filter((inv) => ['issued', 'partially_paid', 'overdue'].includes(inv.status));
  const totalPaid = invoices.filter((inv) => inv.status === 'paid');
  const issued = invoices.filter((inv) => inv.status === 'issued');

  const columns = [
    {
      title: 'Factura',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Cliente',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: 'Período',
      key: 'service_period',
      render: (_, record) => formatPeriod(record.service_period_from, record.service_period_to),
    },
    {
      title: 'Monto',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (amount) => formatCurrency(amount),
    },
    {
      title: 'Vencimiento',
      dataIndex: 'due_date',
      key: 'due_date',
      render: (date) => formatDate(date),
    },
  ];

  const issuedColumns = [
    {
      title: 'Factura',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Cliente',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: 'Período',
      key: 'service_period',
      render: (_, record) => formatPeriod(record.service_period_from, record.service_period_to),
    },
    {
      title: 'Total',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (amount) => formatCurrency(amount),
    },
    {
      title: 'Saldo Pendiente',
      dataIndex: 'remaining_amount',
      key: 'remaining_amount',
      render: (amount) => formatCurrency(amount),
    },
    {
      title: 'Vencimiento',
      dataIndex: 'due_date',
      key: 'due_date',
      render: (date) => formatDate(date),
    },
  ];

  return (
    <div className="dashboard-page">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card pending">
            <Statistic
              title="Facturas Pendientes"
              value={totalPending.length}
              prefix={<ExclamationCircleOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card overdue">
            <Statistic
              title="Facturas Vencidas"
              value={overdue.length}
              prefix={<WarningOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card paid">
            <Statistic
              title="Facturas Pagadas"
              value={totalPaid.length}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12}>
          <Card className="stat-card">
            <Statistic
              title="Total Pendiente por Cobrar"
              value={portfolioReport?.total_pending || 0}
              prefix={<DollarOutlined />}
              valueStyle={{ color: '#f5222d' }}
              formatter={(value) => formatCurrency(value)}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card className="stat-card">
            <Statistic
              title="Total Vencido"
              value={portfolioReport?.total_overdue || 0}
              prefix={<DollarOutlined />}
              valueStyle={{ color: '#faad14' }}
              formatter={(value) => formatCurrency(value)}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }} title="Últimas Facturas Vencidas">
        <Table
          dataSource={overdue.slice(0, 10)}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Card>

      <Card style={{ marginTop: 24 }} title="Facturas Emitidas">
        <Table
          dataSource={issued}
          columns={issuedColumns}
          rowKey="id"
          pagination={{ pageSize: 10, showSizeChanger: false }}
          size="small"
        />
      </Card>
    </div>
  );
};

export default DashboardPage;
